import React, { Component } from 'react';
import '../../resources/components/ui-component-notification-toggle-group.scss'
import {
    getNotificationCategories,
} from "../../actions/notifications";
import {connect} from "react-redux";
import Loader from "../../components/common/Spinners/Loader";

class NotificationCategories extends Component {

    state = {
        isToggled: false,
        isDisabled: false,
        isLoading: false,
        allCommunicationsToggled: null,
        notificationCategoriesState: [],

    };

    componentDidMount() {
        this.checkNotificationsToggled()
        this.setState({notificationCategoriesState: this.props.notificationCategoriesData})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.notificationCategoriesData !== this.props.notificationCategoriesData) {

            this.setState({notificationCategoriesState: this.props.notificationCategoriesData}, () => this.checkNotificationsToggled())
        }
    }


    //checks if all communications toggle needs to be checked or not on load
    checkNotificationsToggled = () => {
        let optOutNotificationPresent = false;
        this.state.notificationCategoriesState.map((category) => {
            category.notificationPreferences.map((preference) => {
                if (preference.notificationType === 'EMAIL' || preference.notificationType === 'TWILIOMSG') {
                    if (!preference.optedIn) {
                        optOutNotificationPresent = true;
                        this.setState({ allCommunicationsToggled: false });
                        return false;
                    }
                }
            });
        });
        if (!optOutNotificationPresent) {
            this.setState({ allCommunicationsToggled: true });
            return true;
        }
    };

    handleToggle = () => {
        this.setState((prevState) => ({
            isToggled: !prevState.isToggled
        }));
    };

    handleAllNotificationOptInOut = () => {
        const lastToggleValue = this.state.allCommunicationsToggled;
        this.setState({ allCommunicationsToggled: !this.state.allCommunicationsToggled, isLoading: true });

        let newNotificationCategoriesState = this.state.notificationCategoriesState.map((category) => {
            let newPreferences = category.notificationPreferences.map((preference) => {
                if (preference.notificationType === 'EMAIL' || preference.notificationType === 'TWILIOMSG') {
                    return { ...preference, optedIn: !preference.optedIn };
                }
                return preference;
            });
            return { ...category, notificationPreferences: newPreferences };
        });

        this.setState({ notificationCategoriesState: newNotificationCategoriesState });

        this.props.notificationCategoriesData.map((notificationCategory) => {
            notificationCategory.notificationPreferences.map((preference) => {
                if (preference.notificationType === 'EMAIL' || preference.notificationType === 'TWILIOMSG') {
                    if (lastToggleValue) {
                        this.props.handleNotificationUnsubscribe({
                            notificationCategoryId: notificationCategory.id,
                            type: preference.notificationType
                        });
                    } else {
                        this.props.handleNotificationSubscribe({
                            notificationCategoryId: notificationCategory.id,
                            type: preference.notificationType
                        });
                    }
                }
            });
        });

        setTimeout(() => {
            this.props.getNotificationCategories(this.props.accountId);
            this.setState({ isLoading: false });
        }, 5000);
    };


    notificationOnClickHandler = async (notificationCategory, type) => {
        const { handleNotificationSubscribe, handleNotificationUnsubscribe } = this.props;
        this.setState({ isLoading: true });

        let newNotificationCategoriesState = this.state.notificationCategoriesState.map((category) => {
            if (category.id === notificationCategory.id) {
                let newPreferences = category.notificationPreferences.map((preference) => {
                    if (preference.notificationType === type) {
                        if (!preference.optedIn) {
                            handleNotificationSubscribe({
                                notificationCategoryId: category.id,
                                type: type
                            });
                        } else {
                            handleNotificationUnsubscribe({
                                notificationCategoryId: category.id,
                                type: type
                            });
                        }
                        return { ...preference, optedIn: !preference.optedIn };
                    }
                    return preference;
                });
                return { ...category, notificationPreferences: newPreferences };
            }
            return category;
        });

        this.setState({ notificationCategoriesState: newNotificationCategoriesState }, () => this.checkNotificationsToggled());
        this.setState({ isLoading: false });
    }


    render() {
        const {
            allCommunicationsToggled,
            notificationCategoriesState,
            isLoading
        } = this.state;

        return (
            <div className="container-client-notifications-settings">
                {isLoading ? (<div className="loader"><Loader/></div>) :
                    (<div>
                        <div className='comm-preferences-group-toggle'>
                            <div>All Communications</div>
                            <div className="form-check checkbox-slider checkbox-slider--b-flat"
                                 style={{marginTop: '3px'}}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={allCommunicationsToggled}
                                        onClick={() => {
                                            this.handleAllNotificationOptInOut()
                                        }}
                                    />
                                    <span>&nbsp;</span>
                                </label>
                            </div>
                        </div>
                        {allCommunicationsToggled === false &&
                            <div className='toggle-group'>
                                <div className='toggle-col'>
                                    <span>&nbsp;</span>
                                    <label>Email</label>
                                    <label>Text</label>
                                </div>
                                {notificationCategoriesState.map((notificationCategory) => {
                                    if (notificationCategory.notificationPreferences.length > 0) {
                                        return (
                                            <div className='toggle-col'>
                                                <div>{notificationCategory.description}</div>
                                                {notificationCategory.notificationPreferences.map((preference) => {
                                                    if (preference.notificationType === "EMAIL" || preference.notificationType === "TWILIOMSG") {
                                                        return (
                                                            <div className="form-check checkbox-slider checkbox-slider--b-flat" style={{marginTop: '5px'}}>
                                                                <label>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={preference.optedIn}
                                                                        onClick={() => {
                                                                            this.notificationOnClickHandler(notificationCategory, preference.notificationType)
                                                                        }}
                                                                    />
                                                                    <span>&nbsp;</span>
                                                                </label>
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        }
                    </div>)}
            </div>
        );
    }
}


const mapDispatchToProps = {
    getNotificationCategories
};


export default connect(null, mapDispatchToProps)(NotificationCategories);
